/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cas_Show_Capital_Account_StatementInputs */

const en_cas_show_capital_account_statement = /** @type {(inputs: Cas_Show_Capital_Account_StatementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show capital account statement in portal`)
};

/**
* | output |
* | --- |
* | "Show capital account statement in portal" |
*
* @param {Cas_Show_Capital_Account_StatementInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_show_capital_account_statement = /** @type {((inputs?: Cas_Show_Capital_Account_StatementInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Show_Capital_Account_StatementInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_show_capital_account_statement(inputs)
});